import PropTypes from "prop-types"
import React, { useState, useEffect } from "react"
import { connect } from "react-redux"

/**
 * Product main image slider
 * @property {array} availableViews - product available view keys
 * @property {bool} blur - blurs image when wizard is loading
 * @property {object} slides - product images + videos data object
 * @property {array} videos - product videos
 */
export default function withImages(WrappedComponent) {
  const InternalImages = ({ slides, ...props }) => {
    if (!props.availableViews) {
      return null
    }
    const [blur, setBlur] = useState(!!props.wizardLoading)
    const [allSlides, setAllSlides] = useState(slides || {})

    // These set of useEffect ensures images always blur on route change
    useEffect(() => {
      // Unset and blur image when wizard is loading, so that old image does not remain on page
      if (props.wizardLoading) {
        setAllSlides({})
        setBlur(true)
      }
    }, [props.wizardLoading])

    // Update image when new images are set in state
    useEffect(() => {
      setAllSlides(slides)
    }, [slides])

    return (
      <WrappedComponent slides={allSlides} {...props} {...{ blur, setBlur }} />
    )
  }

  InternalImages.propTypes = {
    availableViews: PropTypes.array,
    slides: PropTypes.object,
    wizardLoading: PropTypes.string,
  }

  const mapStateToProps = (state) => {
    let availableViews = []
    let slides = {}
    let slidesArray = []

    if (state.previewImage.data) {
      slides = state.previewImage.data.images
      availableViews = state.previewImage.data.all_views.filter((view) => {
        return slides[view] || slides[`${view}_view`]
      })
      slidesArray = availableViews.map((view) => {
        let slide = slides[`${view}_view`] || slides[view]
        slide.view = view
        // get face2 for flip rings
        if (
          state.previewImageUI.flipped &&
          typeof slides[`face2_${view}_view`] !== "undefined"
        ) {
          slide = slides[`face2_${view}_view`]
          slide.view = `face_2_${view}`
        }
        return slide
      })
    }

    const j3dSlideIndex = slidesArray.findIndex((slide) => slide.view === "j3d")

    return {
      availableViews,
      j3dSlideIndex,
      productType: state.wizard.description.product_type,
      slides,
      slidesArray,
      styleCode: state.wizard.description.style_code,
      wizardLoading: state.wizard.loading,
    }
  }

  const mapDispatchToProps = () => {
    return {}
  }

  const Images = connect(mapStateToProps, mapDispatchToProps)(InternalImages)

  return Images
}
